import { useEffect } from 'react'
import { useTenantSettings } from '@/features/company/queries'
import { setTenantLocale } from '@/lib/locale'

/**
 * Mounted once inside any authenticated shell. Pushes the tenant's saved
 * Regional Settings (country/currency/locale/date_format/fiscal_year_start)
 * into the locale module cache so every `formatCurrency`/`formatDate` call -
 * and every form that reads the tenant defaults via `useRegionalDefaults` -
 * sees the same values without each component refetching.
 */
export function TenantLocaleSync() {
  const { data } = useTenantSettings()
  useEffect(() => {
    if (data?.tenant) setTenantLocale(data.tenant)
  }, [data])
  return null
}
